import { authorize } from '../../helper/authorize-token';
import superagent from 'superagent';

const getPotentialIRR = async (token, queryParams) => {
    try {
        const response = await superagent.agent()
            .get(`/api/dashboard/get-account-portfolio-irr?${queryParams}`)
            .use(authorize(token))

        return response.body;
    } catch (error) {
        console.log('Error fetching data: ', error);
        throw error;
    }
}

export { getPotentialIRR };